// Read the readme.md first.
import Vue from 'vue'
export default new Vue()
